export { PartExIcon } from './part-ex'
